import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import StaticImage from "utilFunctions/shared/StaticImage";
const SpanBannerSubHeading = styled<any>("span")`
  color: var(--White, #fff);
  font-size: 28px;
  font-size: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "28px" : "20px"};
  font-style: normal;
  font-weight: 700;
  line-height: 40px; /* 142.857% */
`;

interface productTourDetails {
  imgUrl: string;
  heading: string;
  description?: string;
}
const ProductTourBanner = ({ heading, imgUrl }: productTourDetails) => {
  const { screen }: any = useWindowSize();
  return (
    <div className="d-flex align-items-center flex-column">
      <StaticImage
        loading="eager"
        alt="Login Carousal Image"
        srcList={[
          {
            type: "web",
            src: imgUrl,
          },
        ]}
        className="mx-auto aspect-auto object-contain"
      />
      <div className="mt-4">
        <SpanBannerSubHeading screen={screen}>{heading}</SpanBannerSubHeading>
      </div>
    </div>
  );
};

export default ProductTourBanner;
